import { render, staticRenderFns } from "./DeyeConsumerComponentSettings.vue?vue&type=template&id=b74c6fac&scoped=true&"
import script from "./DeyeConsumerComponentSettings.vue?vue&type=script&lang=ts&"
export * from "./DeyeConsumerComponentSettings.vue?vue&type=script&lang=ts&"
import style0 from "./DeyeConsumerComponentSettings.vue?vue&type=style&index=0&id=b74c6fac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74c6fac",
  null
  
)

export default component.exports